import { MessageCircle } from "lucide-react";
import { buildWhatsAppUrl } from "../../lib/whatsapp";

export function FloatingWhatsApp() {
  return (
    <a
      href={buildWhatsAppUrl()}
      className="floating-whatsapp"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Falar com a Pastelaria Casagrande pelo WhatsApp"
      data-tooltip="Fale connosco"
    >
      <MessageCircle aria-hidden="true" />
    </a>
  );
}
